import { CHANNELS } from "./channels";
import { domainOf, compact, matchDomainByName, businessName } from "./domains";

// One row per business, across every channel.
// Businesses are matched by website domain. Listings without a readable
// website are matched by name, and flagged as a "likely" match.
export function buildCompetitorMap(results) {
  const known = new Set();
  results.forEach(r => {
    [...r.paid, ...r.organic].forEach(i => { const d = i._domain || domainOf(i.url, i.url_shown); if (d) known.add(d); });
    [...r.localPack, ...r.shopping, ...r.lsa].forEach(i => { if (i._domain) known.add(i._domain); });
  });
  const knownDomains = [...known];

  const map = {};
  const add = (r, channel, item) => {
    let domain = null;
    let bizName = null;
    let likely = false;

    if (channel === "ppc" || channel === "seo") {
      domain = item._domain || domainOf(item.url, item.url_shown);
    } else {
      bizName = businessName(item, channel);
      domain = item._domain || null;
      if (!domain) {
        domain = matchDomainByName(bizName, knownDomains);
        if (domain) likely = true;
      }
    }

    const key = domain ? `d:${domain}` : `n:${compact(bizName) || "unknown"}`;
    if (!map[key]) map[key] = { key, name: domain || bizName || "Unknown", domain, businessNames: new Set(), likely: false, ppc: 0, gbp: 0, seo: 0, shopping: 0, lsa: 0, locations: new Set(), keywords: new Set(), total: 0, ads: [] };
    const c = map[key];
    if (bizName && bizName !== c.name) c.businessNames.add(bizName);
    if (likely) c.likely = true;
    c[channel]++; c.total++;
    c.locations.add(r.location); c.keywords.add(r.keyword);
    if (channel === "ppc") c.ads.push({ ...item, type: "PPC", location: r.location, keyword: r.keyword, round: r.round });
  };

  results.forEach(r => {
    r.paid.forEach(i => add(r, "ppc", i));
    r.localPack.forEach(i => add(r, "gbp", i));
    r.organic.forEach(i => add(r, "seo", i));
    r.shopping.forEach(i => add(r, "shopping", i));
    r.lsa.forEach(i => add(r, "lsa", i));
  });

  Object.values(map).forEach(c => {
    c.locations = [...c.locations];
    c.keywords = [...c.keywords];
    c.businessNames = [...c.businessNames];
    c.channelCount = CHANNELS.filter(ch => c[ch] > 0).length;
  });
  return Object.values(map).sort((a, b) => b.total - a.total);
}
